// StepNav.tsx
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCommissionStore } from "../stores/commissionStore";
import { useIntakeCopy } from "../i18n/useIntakeCopy";

export function StepNav({ canNext, onNext, nextLabel, hideBack, busy }: {
  canNext: boolean; onNext?: () => void; nextLabel?: string; hideBack?: boolean; busy?: boolean;
}) {
  const { c } = useIntakeCopy();
  const back = useCommissionStore((s) => s.back);
  const next = useCommissionStore((s) => s.next);
  return (
    <div className="mt-8 flex items-center justify-between gap-3 border-t border-[var(--color-border)] pt-6">
      {hideBack ? <span /> : (
        <Button type="button" variant="ghost" onClick={back}><ArrowLeft className="mr-2 h-4 w-4" />{c.nav.back}</Button>
      )}
      <Button type={onNext ? "button" : "submit"} size="lg" disabled={!canNext || busy} onClick={onNext ?? next}>
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
        {nextLabel ?? c.nav.next}
        {!busy && <ArrowRight className="ml-2 h-4 w-4" />}
      </Button>
    </div>
  );
}
